export const mustReplaceSpeakerFieldsWithMemberInfo = () =>
  window.APP_CLIENT_NAME === "openstack";
